import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "../redux/auth-store";
import storage from "../helpers/storage";
import { logRoute } from "../utils/performance";

/** Logs route + auth context on every navigation (dev diagnostics). */
export default function RouteDiagnostics() {
  const location = useLocation();
  const { token, user } = useAuthStore();

  useEffect(() => {
    logRoute(location.pathname, {
      hasToken: !!(token || storage.getToken()),
      userId: user?.id,
    });
    if (
      location.pathname.includes("ptt-channels") &&
      document.referrer.includes("/login")
    ) {
      console.warn(
        "[PTT Perf] Landed on /ptt-channels right after login — if dashboard was expected, the server may be serving an OLD frontend build. Hard-refresh (Ctrl+Shift+R) or redeploy PTTfrontend/build.",
      );
    }
  }, [location.pathname, token, user?.id]);

  return null;
}
